module.exports = __webpack_public_path__ + "img/btnIcon.10b8ca3b.png";